<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Extrato Financeiro         
    </h1>
</header>

<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="main__content col-xl-12 px-2">
    <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
        (ngSubmit)="consultar()">
        <section class="content-form">
            <div class="col-12 mb-2 px-1">
                <label class="content__form__title__label">Selecione quem deseja consultar</label>
                <ng-select bindLabel="name" bindValue="id" placeholder="Selecione um Titular" [clearable]="false" [searchable]="false"
                    [items]="beneficiaries" formControlName="personCpf">
                </ng-select>
            </div>
            <div class="row">
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data inicio</label>
                    <input type="month" class="form-control input-form" formControlName="initialDate"
                        placeholder="MM-YYYY" (click)="periodoSelecionadoData()" max="{{maxMonth | date:'yyyy-MM'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('initialDate')?.touched && formGroup.get('initialDate')?.invalid">
                        O campo Data inicio está inválido!
                    </small>
                </div>
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data fim</label>
                    <input type="month" class="form-control input-form" formControlName="finalDate"
                        placeholder="MM-YYYY" (click)="periodoSelecionadoData()" max="{{maxMonth | date:'yyyy-MM'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('finalDate')?.touched && formGroup.get('finalDate')?.invalid">
                        O campo Data fim está inválido!
                    </small>
                </div>
            </div>
            <section class="col-12 px-1 mt-1">
                <label class="form-check-label content__form__title__label">Período</label>
                <div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="period" type="radio" name="period"
                            id="trintaDias" (click)="periodoSelecionado()" [value]="30" value="true">                                                    
                        <label class="form-check-label form-check-label-extrato" for="trintaDias">1 mês</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="period" id="sessentaDias" name="period"
                            type="radio" (click)="periodoSelecionado()" [value]="90">
                        <label class="form-check-label form-check-label-extrato" for="sessentaDias">3 meses</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" formControlName="period" id="noventaDias" name="period"
                            type="radio" (click)="periodoSelecionado()" [value]="180">
                        <label class="form-check-label form-check-label-extrato" for="noventaDias">6 meses</label>
                    </div>
                </div>
            </section>
        </section>
        <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
            [disabled]="this.loading">
            <div class="d-flex" *ngIf="loading; else showSpan" [@fadeIn]>
                <span>Consultando</span>
            </div>
            <ng-template #showSpan>
                <span [@fadeIn]>Consultar</span>
            </ng-template>
        </button>
    </form>
    <section class="content__resultado__main" *ngIf="!loading; else showLoading" [@fadeIn]>
        <aviso
            [textoAviso]="'O valor total das despesa(s) de saúde (Mensalidade + Coparticipação)do período selecionado ' + 
                    (formGroup.value.initialDate | date:'MMMM - yyyy') + ' de até '+ (formGroup.value.finalDate | date:'MMMM - yyyy') +' de é de'"
            [valor]="((extratoFinanceiro.total | currency:'BRL':'symbol':'1.2-2':'pt') ?? 0)"
            *ngIf="medicoHospitalar && medicoHospitalar?.items.length > 0">
        </aviso>
        <ng-template #naoPossuiMedicoHospitalar>
            <p class="col-12 aviso-sem-resultado">
                Não localizamos guias disponíveis neste período!!
            </p>
        </ng-template>
        <section class="content__space content-medico-hospitalar col-xl-12 pl-0 pr-0">
            <div class="content_download_pdf">
                <div>
                    <h3 class="content_download_pdf_title">
                        Exportar
                    </h3>
                </div>
                <section class="d-flex">
                    <button [disabled]="this.loading">
                        <div class="d-flex" *ngIf="loadingPdf; else showLoadingPdf">
                            <span class="spinner-button-export">
                            </span>
                        </div>
                        <ng-template #showLoadingPdf>
                            <fa-icon [icon]="faPdf" (click)="printPdf()"></fa-icon>
                        </ng-template>
                    </button>
                    <button [disabled]="this.loading">
                        <div class="d-flex" *ngIf="loadingCsv; else showLoadingCsv">
                            <span class="spinner-button-export">
                            </span>
                        </div>
                        <ng-template #showLoadingCsv>
                            <fa-icon [icon]="faExcel" (click)="printCsv()"></fa-icon>
                        </ng-template>
                    </button>
                </section>
            </div>
            

            <ng-template #loadingGrid>
                <spinner-grid />
            </ng-template>

            
                <header class="content__header">
                    <h3>Médico Hospitalar</h3>
                    <filtro-dados [pageItens]="5" [totalItens]="medicoHospitalar?.totalFiltered"
                        (changeQuantidade)="onChangeQuantidadeItensMedicoHospitalar($event)"
                        *ngIf="medicoHospitalar && medicoHospitalar?.items.length > 0">
                    </filtro-dados>
                </header>
                <section *ngIf="!loadingPaginacaoMedico else loadingGrid">
                <main class="content__resultado__grid__main"
                    *ngIf="medicoHospitalar && medicoHospitalar?.items.length > 0 else naoPossuiMedicoHospitalar">
                    <section class="content__header__table">
                        <div class="col-xl-1">Nº guia</div>
                        <div class="col-xl-2 display-sm-none">Prestador</div>
                        <div class="col-xl-2">Realização</div>
                        <div class="col-xl-2">Pagamento</div>
                        <div class="col-xl-2 display-sm-none">Valor Pago</div>
                        <div class="col-xl-2 display-sm-none">Coparticipação</div>
                        <div class="col-xl-1">Ações</div>
                    </section>
                    <section class="content__main__table">
                        <div class="table__card" *ngFor="let doctorGuide of medicoHospitalar?.items; let i = index">
                            <div class="col-xl-1">{{doctorGuide.code}}</div>
                            <div class="col-xl-2 display-sm-none">{{ doctorGuide.provider | slice: 0:20 }}...</div>
                            <div class="col-xl-2">{{ doctorGuide.serviceDate | date: 'dd/MM/yyyy' }}</div>
                            <div class="col-xl-2">{{ doctorGuide.paymentDate | date: 'dd/MM/yyyy' }}</div>
                            <div class="col-xl-2 display-sm-none">{{ doctorGuide.totalValue |
                                currency:'BRL':'symbol':'1.2-2':'pt' }}</div>
                            <div class="col-xl-2 display-sm-none">{{ doctorGuide.coparticipationValue |
                                currency:'BRL':'symbol':'1.2-2':'pt' }}</div>
                            <div class="col-xl-1">
                                <a (click)="visualizarGuiaMedica(doctorGuide)">
                                    <fa-icon class="fa-icon icon-eye" [icon]="faEye"></fa-icon>
                                </a>
                            </div>
                        </div>
                    </section>
                </main>          
                </section>  
                
                <footer *ngIf="medicoHospitalar && medicoHospitalar?.items.length > 0">
                    <paginacao [currentPage]="filtroMedico.page" (changeNumber)="paginacaoMedicoHospitalar($event)" [collectionSize]="medicoHospitalar?.totalFiltered" [pageSize]="medicoHospitalar?.itemsPerPage">
                    </paginacao>
                </footer>
            

        </section>

        <ng-template #naoPossuiMensalidades>
            <p class="col-12 aviso-sem-resultado">
                Não localizamos mensalidades neste período!
            </p>
        </ng-template>

        <section class="content-mensalidades" >
            <header class="content__header">
                <h3>Mensalidades</h3>
                <filtro-dados [pageItens]="5" [totalItens]="mensalidades?.totalFiltered"
                    (changeQuantidade)="onChangeQuantidadeItensMensalidades($event)"
                    *ngIf="mensalidades && mensalidades?.items.length > 0">
                </filtro-dados>
            </header>
            <section *ngIf="!loadingPaginacaoMensalidade else loadingGrid">
                <main *ngIf="mensalidades && mensalidades?.items.length > 0 else naoPossuiMensalidades">
                    <section class="content__header__table">
                        <div class="col-xl-4">Data Pagamento</div>
                        <div class="col-xl-4">Valor Pago</div>
                        <!-- <div class="col-xl-4">Beneficiário</div> -->
                    </section>
                    <section class="content__main__table">
                        <div class="table__card" *ngFor="let monthlyFee of mensalidades?.items">
                            <div class="col-xl-4">
                                <span>
                                    {{monthlyFee.paymentDate | date: 'dd/MM/yyyy'}}
                                </span>
                            </div>
                            <div class="col-xl-4">
                                <span>
                                    {{monthlyFee.totalValue | currency:'BRL':'symbol':'1.2-2':'pt'}}
                                </span>
                            </div>
                        </div>
                    </section>
                </main>
            </section>
            <footer *ngIf="mensalidades && mensalidades?.items.length > 0">
                <paginacao [currentPage]="filtroMensalidades.page" (changeNumber)="paginacaoMensalidades($event)" [collectionSize]="mensalidades?.totalFiltered" [pageSize]="mensalidades?.itemsPerPage">
                </paginacao>
            </footer>
        </section>
    </section>

</main>